import { useState } from "react";
import { useForm } from "react-hook-form";

import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { IModuloComCategorias } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import { IEmpreendimento } from "../../../../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import SelectCategoriaAtendimento from "../../../../../../CardsPages/Forms/SelectCategoriaAtendimento";
import { CadastrarSubCategoriaController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/SubCategoria/SubCategoriaControllers";
import { ISubCategoria as ISubCategorias } from "../../../../../../../Interfaces/Geral/SubCategoria/SubCategoriaInterface";

interface IListagemProps {
    lstEmpreendimento: Array<IEmpreendimento>;
    lstModulos: Array<IModuloComCategorias>;
}

interface ICadastrarFormData {
    DS_SUB_CATEGORIA: string;
    IDCategoria: number;
    IDProduto: number;
}

export default function Cadastro(props: IListagemProps) {
    const { register, handleSubmit, formState, reset, control } =
        useForm<ICadastrarFormData>();
    const [idModulo, setIdModulo] = useState<number>();

    function handleCadastrarFormSubmit(formData: ISubCategorias) {
        CadastrarSubCategoriaController({
            DS_CATEGORIA_ATENDIMENTO: formData.DS_CATEGORIA_ATENDIMENTO,
            DS_PRODUTO: formData.DS_PRODUTO,
            DS_SUBCATEGORIA_ATENDIMENTO: formData.DS_SUBCATEGORIA_ATENDIMENTO,
            ID_CATEGORIA_ATENDIMENTO: formData.ID_CATEGORIA_ATENDIMENTO,
            ID_PRODUTO: formData.ID_PRODUTO,
            ID_SUB_CATEGORIA_ATENDIMENTO: formData.ID_SUB_CATEGORIA_ATENDIMENTO,
        }).then(() => reset());
    }

    return (
        <form
            onSubmit={handleSubmit(handleCadastrarFormSubmit)}
            className="row"
        >
            <div className="form-group col-12 col-lg-6">
                <label>Subcategoria</label>
                <input
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.DS_SUB_CATEGORIA && "is-invalid"
                    }`}
                    type="text"
                    name="DS_SUBCATEGORIA_ATENDIMENTO"
                    ref={register({
                        required: "Insira o nome da subcategoria",
                    })}
                />
                <div className="invalid-feedback">
                    {formState.errors.DS_SUB_CATEGORIA
                        ? formState.errors.DS_SUB_CATEGORIA.message
                        : ""}
                </div>
            </div>
            <div className="form-group col-12 col-lg-6">
                <label>Tipo Caso</label>
                <select
                    className={`form-control placeholder-dark-75`}
                    onChange={(e) => setIdModulo(Number(e.target.value))}
                >
                    <option></option>
                    {props.lstModulos.map((modulo) => (
                        <option value={modulo.ID_MODULO} key={modulo.ID_MODULO}>
                            {modulo.DS_MODULO}
                        </option>
                    ))}
                </select>
            </div>
            <div className="form-group col-12 col-lg-6">
                <label>Categoria</label>
                <SelectCategoriaAtendimento
                    ID_MODULO={idModulo}
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.IDCategoria && "is-invalid"
                    }`}
                    name="ID_CATEGORIA_ATENDIMENTO"
                    control={control}
                    rules={{
                        required: "Insira a Categoria",
                    }}
                />
                <div className="invalid-feedback">
                    {formState.errors.IDCategoria
                        ? formState.errors.IDCategoria.message
                        : ""}
                </div>
            </div>
            <div className="form-group col-12 col-lg-6">
                <label>Empreendimento</label>
                <select
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.IDProduto && "is-invalid"
                    }`}
                    name="ID_PRODUTO"
                    ref={register({
                        valueAsNumber: true,
                    })}
                >
                    <option></option>
                    {props.lstEmpreendimento.map((empreendimento) => (
                        <option
                            value={empreendimento.ID_EMPREENDIMENTO}
                            key={empreendimento.ID_EMPREENDIMENTO}
                        >
                            {empreendimento.DS_EMPREENDIMENTO}
                        </option>
                    ))}
                </select>
                <div className="invalid-feedback">
                    {formState.errors.IDProduto
                        ? formState.errors.IDProduto.message
                        : ""}
                </div>
            </div>

            <div className="col-12">
                <button
                    type="submit"
                    className="btn btn-outline-success font-weight-bold col-12 justify-content-center"
                >
                    <FontAwesomeIcon icon={faPlus} size="lg" className="mr-1" />{" "}
                    Cadastrar
                </button>
            </div>
        </form>
    );
}
